<!-- Bulk Detailed Response Dialog -->
<div class="bulk-detailed-response-dialog">
  <!-- Action Summary -->
  <div class="mb-4 p-3 border-round-lg surface-100">
    <div class="flex align-items-center gap-2 mb-3 items-center">
      <i class="pi pi-info-circle text-600"></i>
      <span class="text-900 font-medium">{{ data.message }}</span>
    </div>

    <!-- Summary Stats -->
    <div class="flex align-items-center gap-3 flex-wrap">
      <div
        class="stat-badge stat-badge-success"
        [class.stat-badge-active]="statusFilter === 'success'"
        (click)="toggleFilter('success')"
      >
        <i class="pi pi-check-circle"></i>
        <span class="stat-number">{{ getSummaryStats().succeeded }}</span>
        <span class="stat-label">Succeeded</span>
      </div>
      <div
        class="stat-badge stat-badge-error"
        [class.stat-badge-active]="statusFilter === 'error'"
        (click)="toggleFilter('error')"
      >
        <i class="pi pi-times-circle"></i>
        <span class="stat-number">{{ getSummaryStats().failed }}</span>
        <span class="stat-label">Failed</span>
      </div>
      <div
        class="stat-badge stat-badge-neutral"
        [class.stat-badge-active]="statusFilter === 'all'"
        (click)="toggleFilter('all')"
      >
        <i class="pi pi-list"></i>
        <span class="stat-number">{{ getSummaryStats().total }}</span>
        <span class="stat-label">Total</span>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  <div
    *ngIf="data.isLoading"
    class="flex justify-content-center align-items-center p-4"
  >
    <p-progressSpinner
      strokeWidth="4"
      [style]="{ width: '50px', height: '50px' }"
    />
  </div>

  <!-- Empty State -->
  <div
    *ngIf="!data.isLoading && filteredResponses.length === 0"
    class="empty-state"
  >
    <div class="empty-state-content">
      <i class="pi pi-inbox"></i>
      <h3>No Results</h3>
      <p>No bulk action results to display.</p>
    </div>
  </div>

  <!-- Results Table -->
  <div
    *ngIf="!data.isLoading && filteredResponses.length > 0"
    class="bulk-response-table"
  >
    <p-table
      [value]="filteredResponses"
      [scrollable]="true"
      scrollHeight="flex"
      styleClass="p-datatable-sm"
      [rowHover]="true"
    >
      <ng-template pTemplate="header">
        <tr>
          <th class="w-2">Order ID</th>
          <th class="w-1">Status</th>
          <th class="w-9">Details</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-response>
        <tr
          [ngClass]="{
            'bulk-response-error': response.Failed,
            'bulk-response-success': !response.Failed,
          }"
        >
          <!-- Scheduled Order ID with link -->
          <td>
            <a
              class="order-id-link font-semibold text-primary-600 hover:text-primary-700 cursor-pointer no-underline"
              (click)="goToScheduledOrderEdit(response.ScheduledOrderId)"
              pTooltip="Click to edit order"
              tooltipPosition="top"
            >
              #{{ response.ScheduledOrderId }}
            </a>
          </td>

          <!-- Result -->
          <td>
            <p-tag
              [value]="getResultText(response.Failed)"
              [severity]="getResultSeverity(response.Failed)"
              [rounded]="true"
            />
          </td>

          <!-- Message -->
          <td class="text-sm text-700">
            {{ response.Message }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
